<template>
  <v-card :disabled="isProcessing" :loading="isProcessing">
    <template v-slot:progress>
      <v-progress-linear
        absolute
        color="success"
        height="4"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-tabs v-model="tab" class="deep-gl" left dark icons-and-text>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1">
        <v-toolbar-title>{{ $t("FIELD_TAGS.TYPES_TITLE") }}</v-toolbar-title>
      </v-tab>
      <v-spacer></v-spacer>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text class="pa-0">
            <Table
              v-if="userStatePrepared"
              ref="field-tag-types-table"
              height="500"
              name="field-tag-types-table"
              :headers="headers"
              :blink-row-item-key="blinkRowItemKey"
              :server-data-options="{ method: tableItemsMethod }"
              :items-per-page="100"
              :loading="isProcessing"
              dense
              fixed-header
              multi-sort
              filterable
            >
              <template
                v-for="(header, index) in headers"
                v-slot:[`item.${header.value}`]="{ item }"
              >
                <span
                  v-if="header.value === 'options'"
                  :key="index"
                  class="d-flex align-center justify-center flex-nowrap"
                >
                  <v-btn
                    icon
                    color="indigo"
                    :to="{ name: 'field-tags', params: { fieldTagTypeId: item.item.id } }"
                    @click="rememberTableRow(item.item.id)"
                  >
                    <v-icon dark>mdi-eye</v-icon>
                  </v-btn>
                </span>
                <template v-else>
                  {{ item.value || "-" }}
                </template>
              </template>
            </Table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import Table from "@/views/partials/v-table/Table.vue";
import userStateService from "@/common/userState.service.js";
import {
  GET_FIELD_TAG_TYPES,
} from "@/store/fieldTagTypes.module";

export default {
  name: "ListFieldTagTypes",
  components: {
    Table,
  },
  data() {
    return {
      tableName: "field-tag-types-table",
      blinkRowItemKey: null,
      userStatePrepared: false,
      tab: "tab-1",
      isProcessing: false,
      tableItemsMethod: GET_FIELD_TAG_TYPES,
      headers: [
        { text: "#", value: "id", align: "center", width: "15%" },
        { text: this.$t("GENERAL.LABELS.NAME"), value: "name", align: "center", width: "50%" },
        { text: this.$t("FIELD_TAGS.TAGS_TITLE"), value: "field_tags_count", align: "center", width: "15%" },
        { text: this.$t("GENERAL.TABLE.OPTIONS_COLUMN"), value: "options", sortable: false, align: "center", width: "20%" },
      ],
    };
  },
  mounted() {
    this.blinkRowItemKey = userStateService.getState(
      `table-state.${this.tableName}.blinkRowItemKey`,
      null
    );
    this.userStatePrepared = true;
  },
  methods: {
    rememberTableRow(id) {
      userStateService.setState(`table-state.${this.tableName}.blinkRowItemKey`, id);
    },
  },
};
</script>
